import { render, staticRenderFns } from "./lookComment.vue?vue&type=template&id=4272b188&scoped=true"
import script from "./lookComment.vue?vue&type=script&lang=js"
export * from "./lookComment.vue?vue&type=script&lang=js"
import style0 from "./lookComment.vue?vue&type=style&index=0&id=4272b188&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4272b188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4272b188')) {
      api.createRecord('4272b188', component.options)
    } else {
      api.reload('4272b188', component.options)
    }
    module.hot.accept("./lookComment.vue?vue&type=template&id=4272b188&scoped=true", function () {
      api.rerender('4272b188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/shopComment/lookComment.vue"
export default component.exports